<template>
    <nav>
        <v-toolbar flat app dark class="blue">
            <v-toolbar-side-icon @click="drawer = !drawer">
            </v-toolbar-side-icon>
            <v-toolbar-title>
                <span>v-sendai</span>
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <router-link to="/">
            <v-icon>home</v-icon>
            </router-link>

        </v-toolbar>

        <v-navigation-drawer v-model="drawer" app class="blue lighten-4">
            <v-list>
                <v-list-tile>
                    <v-list-tile-title>
                        <span>メインメニュー</span>
                    </v-list-tile-title>
                </v-list-tile>
            </v-list>
            <v-divider></v-divider>

            <v-list dense class="py-3">
                <v-list-tile class="pa-2" v-for="link in links" :key="link.title" router :to="link.route">
                    <v-list-tile-action>
                        <v-icon>{{ link.icon }}</v-icon>
                    </v-list-tile-action>

                    <v-list-tile-content>
                        <v-list-tile-title>{{ link.title }}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>

        </v-navigation-drawer>

    </nav>
</template>
<script>
export default {
    data() {
        return{
            drawer: false,
            links: [
                { title: 'トップページ', icon: 'home', route: '/' },
                { title: '運営メンバー', icon: 'people', route: '/team' },
                { title: '活動記録', icon: 'history', route: '/history'},
                { title: '動作確認ページ', icon: 'report_problem', route: '/test'}
            ]
        }
    }
}
</script>